var e=e=>Object.entries(e).filter(([,e])=>e.enabled);export{e as enabledServiceAccess};
//# sourceMappingURL=enabledServiceAccess.js.map